import { TFunction } from "i18next"
import { useTranslation } from "react-i18next"

export default () => {
	const { t } = useTranslation("tournaments", { keyPrefix: "form.dataTableHeaders.tournaments" })

	return columns(t)
}

const columns = (t: TFunction) => [
	{
		title: "ID",
		dataIndex: "id",
		key: "id",
		sorteable: true,
		width: "5rem"
	},
	{
		key: "service",
		title: t("service"),
		dataIndex: "service",
		width: "20rem"
	},
	{
		key: "user",
		title: t("user"),
		dataIndex: "user",
		filter: true,
		width: "10rem"
	},
	{
		key: "clusters",
		title: t("clusters"),
		dataIndex: "clusters",
		filter: true,
		width: "25rem",
		filterExactText: true
	},
	{
		title: "",
		key: "editButton",
		dataIndex: "editButton",
		width: "3rem"
	}
]
